import React, { useState, useContext } from "react";
import { showDangerToast, showInfoToast } from "../validation/ToastContainer";
import { prepareEnvForUpgrade } from "./upgradeService";
import { getConfirmPopup } from "../view/popup/PopupContainer";
import { PopupContext } from "../index"
import { startUpgrade } from "./upgradeService";
import { CheckCircle2, Upload, FileUp, ChevronDown } from "lucide-react";
import {
  finishLocalProcessingTask,
  startLocalProcessingTask
} from "../processing-tasks/processingTasksRegistry";

export default function UpgradeSection() {

  const hiddenFileInput = React.useRef(null);
  const [preparing, setPreparing] = useState(false);
  const [textinput, setTextinput] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [collapsed, setCollapsed] = useState(false);

  const { setPopup } = useContext(PopupContext);
  const [upgrading, setUpgrading] = useState(false);
  const [isStartDisabled, setisStartDisabled] = useState(true);

  const onPrepareUpgradeClick = event => {
    //alert(preparing);
    if (preparing) {
      return;
    }
    //SetTextV(true);        
    setTextinput('Preparing for Upgrade. When Completed, button "START UPGRADING ..." will be Enabled');
    setPreparing(true);
    hiddenFileInput.current.click();
  };

  const onPrepareUpgradeChange = event => {
    const fileUploaded = event.target.files[0];
    if (fileUploaded) {
      setSelectedFile(fileUploaded);
    }

    setPreparing(true);
    showInfoToast('Preparation of Upgrade Environment is in Process', 'Upgrade');
    const processingTaskId = startLocalProcessingTask({
      id: `upgrade-prepare-${Date.now()}`,
      type: "Upgrade",
      title: "Preparing Upgrade Environment",
      details: fileUploaded?.name || ""
    });

    //setTimeout((success) => prepareEnvForUpgrade(fileUploaded),2000);
    prepareEnvForUpgrade(fileUploaded).then((success) => {
      if (success) {

        //Set this code to enable the Start Upgrade Button
        setTextinput('Upgrade is ready to be started!')
        setisStartDisabled(false)
        setPreparing(false);
      }
      else {
        showDangerToast('Upgrade Files not uploaded', 'Upgrade', 'Something went wrong with Upgrade');

        //Set this code to disable the Start Upgrade Button
        setTextinput('Preparing for Upgrade is Failed!')
        setisStartDisabled(true)
        setPreparing(true);
      }
    }).finally(() => finishLocalProcessingTask(processingTaskId));

    //Set this code to await prepareEnvForUpgrade Function
    //setTextinput('Upgrade is ready to be started!')
    //setisStartDisabled(false)
    //setPreparing(false);

    //Set this code to wait for amount of time before execution
    //setTimeout(()=>setTextinput('Upgrade is ready to be started!'),25000);
    //setTimeout(()=>setisStartDisabled(false),25000);
    //setTimeout(()=>setPreparing(false),25000);
    //setTextinput(false);
    //setisStartDisabled(false);  

  };

  const onStartUpgradingClick = event => {
    showInfoToast('Start Upgrading', 'Upgrade');
    setUpgrading(true);

    const onCancel = async () => {
      setTextinput('Preparing for Upgrade. When Completed, button "START UPGRADING ..." will be Enabled')
      setUpgrading(false);
    }

    const onConfirm = async () => {
      setTextinput('Upgrade will take several minutes. Please wait before continuing your work!')
      const processingTaskId = startLocalProcessingTask({
        id: `upgrade-start-${Date.now()}`,
        type: "Upgrade",
        title: "Octopus VAR Upgrade",
        details: selectedFile?.name || ""
      });
      const success = await startUpgrade().finally(() => finishLocalProcessingTask(processingTaskId));
      if (success) {
        showInfoToast('Upgrade is started', 'Upgrade');
      } else {
        showDangerToast('Upgrade did not complete successfully', 'Upgrade', 'Something went wrong with Upgrade');
      }
      setUpgrading(false);
    };

    setPopup(
      getConfirmPopup(
        'Are you sure?',
        'Upgrade Octopus VAR',
        onConfirm,
        onCancel
      )
    );
  };

  // const onStartUpgradingChange = event => {
  //   if(upgrading){
  //     return;
  // }

  //   };


  // const onTestClick = event => {

  //     showInfoToast('Test Button -3-', 'Upgrade');

  //     const test = testing();
  //       if (test) {
  //         showInfoToast('test starts', 'Upgrade');                    
  //       } else {
  //          showDangerToast('testing did not complete successfully', 'Upgrade', 'Something went wrong with Upgrade');
  //       }

  // };    

  return (
    <>
      <div className="oct_analysis-card-v2 p-4">
        <button
          className="oct_settings-section-header mb-4"
          onClick={() => setCollapsed(!collapsed)}
        >
          <h3>Upload VAR Upgrade File and Upgrade:</h3>
          <ChevronDown
            className={`oct_icon oct_settings-chevron-v2 ${!collapsed ? 'oct_expanded' : ''}`}
          />
        </button>

        <div className={`oct_settings-section-body ${collapsed ? 'oct_collapsed' : 'oct_expanded'}`}>
          <div className="mb-4">
            <div className="oct_upgrade-warning-banner-v2">
              <p>
                <span>Upgrade process takes several minutes.</span> After upgrade done you have to reboot device. Reboot will take couple of minutes.
              </p>
            </div>

            <input className="oct_display-none"
              type="file"
              accept=".tar.gz"
              ref={hiddenFileInput}
              onChange={onPrepareUpgradeChange}
            />

            {selectedFile && (
              <div className="oct_upgrade-file-banner-v2">
                <div className="oct_file-icon-v2">
                  <FileUp className="w-5 h-5 text-white" />
                </div>
                <div className="oct_file-details-v2">
                  <p className="oct_file-label-v2">Selected File:</p>
                  <p className="oct_file-name-v2">{selectedFile.name}</p>
                </div>
              </div>
            )}

            <div className="oct_upgrade-actions-v2">
              <button
                onClick={onPrepareUpgradeClick}
                className="oct_btn-cyan-flex-v2"
              >
                <Upload className="w-4 h-4" />
                PREPARE ENVIRONMENT
              </button>

              <button
                onClick={onStartUpgradingClick}
                disabled={isStartDisabled || upgrading}
                className="oct_btn-success-v2"
              >
                <CheckCircle2 className="w-4 h-4" />
                UPGRADATION
              </button>
            </div>

            {!selectedFile && (
              <div className="oct_upgrade-no-file-v2">
                * Click "PREPARE ENVIRONMENT" to select an upgrade file
              </div>
            )}
          </div>

          {textinput && (
            <div className="mt-4">
              <div className="oct_form-control-default oct_border-none bg-slate-50 p-3 rounded oct_upgrade-pre-container">
                <pre className="oct_upgrade-pre-text">
                  {textinput}
                </pre>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
